export const sidebar = {
  dashboard: '儀表板',
  aiPersonality: 'AI語音人格生成器',
  callTasks: '呼叫設定任務',
  phoneRecords: '電話紀錄',
  outboundRecords: '出站紀錄',
  inboundRecords: '入站紀錄',
  templates: '話術模版',
  analytics: '分析報告',
  billing: '帳戶明細',
  notifications: '重要訊息通知',
};
